import React from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    FormControl,
    FormControlLabel,
    FormLabel,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText
} from "@mui/material";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg"
import "./MiscChargeForm.css"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const MiscChargeFormComponent = ({
    formData,
    handleChange,
    handleSubmit,
    loading,
    partners,
    navigate,
    partnerName,
    setFormData,
    showConfirmationDialog,
    setShowConfirmationDialog,
    handleConfirmSubmit
}) => {
    console.log("partnerName", partnerName)
    const today = new Date().toISOString().split("T")[0];

    return (
        <div className="misc-charge-layout">
            <Sidebar />
            <div className="misc-charge-content">
                <div className="misc-charge-container">
                    <Box className="misc-charge-header">
                        <Button
                            className="back-button"
                            onClick={() => navigate(-1)}
                            aria-label="Go back"
                        >
                            <img src={leftArrow} alt="" />
                        </Button>
                        <Typography variant="h4" className="title">
                            Create Miscellaneous Charge
                        </Typography>
                    </Box>

                    <Card className="misc-charge-card">
                        <CardContent>
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                setShowConfirmationDialog(true);
                            }} className="charge-form">

                                <div className="form-field">
                                    <TextField
                                        fullWidth
                                        label="Partner"
                                        value={partnerName}
                                        InputProps={{ readOnly: true }}
                                    />
                                </div>

                                <div className="form-field">
                                    <TextField
                                        fullWidth
                                        label="Charge Name"
                                        name="chargeName"
                                        value={formData.chargeName}
                                        onChange={handleChange}
                                        required
                                        placeholder="Enter Charge Name"
                                    />
                                </div>

                                <div className="form-field">
                                    <TextField
                                        fullWidth
                                        label="Charge Description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        multiline
                                        rows={3}
                                        placeholder="Enter Charge Description"
                                    />
                                </div>

                                <div className="form-field">
                                    <TextField
                                        fullWidth
                                        label="Effective From"
                                        name="effectiveDate"
                                        type="date"
                                        value={formData.effectiveDate || ""}
                                        onChange={handleChange}
                                        required
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            min: new Date().toISOString().split("T")[0],
                                            max: (() => {
                                                const lastDay = new Date(
                                                    new Date().getFullYear(),
                                                    new Date().getMonth() + 1,
                                                    0
                                                );
                                                lastDay.setHours(23, 59, 59, 999); // ✅ ensure timezone shift fix
                                                return lastDay.toISOString().split("T")[0];
                                            })(),
                                        }}
                                    />
                                </div>


                                <div className="form-field">
                                    <FormControl component="fieldset" fullWidth>
                                        <FormLabel>Charge Type</FormLabel>
                                        <RadioGroup
                                            row
                                            name="chargeType"
                                            value={formData.chargeType}
                                            onChange={handleChange}
                                            className="radio-group"
                                        >
                                            <FormControlLabel
                                                value="credit"
                                                control={<Radio />}
                                                label="Credit"
                                            />
                                            <FormControlLabel
                                                value="debit"
                                                control={<Radio />}
                                                label="Debit"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>

                                <div className="form-field">
                                    <FormControl component="fieldset" style={{ marginBottom: '16px' }}>
                                        <FormLabel component="legend">Select Amount Type</FormLabel>
                                        <RadioGroup
                                            row
                                            value={formData.type}
                                            onChange={(e) =>
                                                setFormData({ ...formData, type: e.target.value })
                                            }
                                        >
                                            <FormControlLabel
                                                value="FIXED"
                                                control={<Radio />}
                                                label="Fixed Amount"
                                            />
                                            <FormControlLabel
                                                value="PER_VM"
                                                control={<Radio />}
                                                label="Amount per VM"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>

                                <div className="form-field">
                                    <TextField
                                        fullWidth
                                        label={formData.type === "FIXED" ? "Amount" : "Amount Per VM"}
                                        name="amount"
                                        type="text"
                                        value={formData.amount}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[0-9]{0,6}$/.test(value)) {
                                                handleChange(e);
                                            }
                                        }}
                                        required
                                        inputProps={{ maxLength: 6 }}
                                    />
                                </div>


                                <div className="form-actions">
                                    <Button
                                        variant="outlined"
                                        onClick={() => navigate(-1)}
                                        disabled={loading}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        style={{
                                            backgroundColor:
                                                loading ||
                                                    !formData.chargeName.trim() ||
                                                    !formData.chargeType ||
                                                    !formData.type ||
                                                    !formData.amount ||
                                                    !formData.effectiveDate
                                                    ? "grey" // 👈 disabled bg
                                                    : "#14AE78",
                                            color: "white",
                                            cursor:
                                                loading ||
                                                    !formData.chargeName.trim() ||
                                                    !formData.chargeType ||
                                                    !formData.type ||
                                                    !formData.amount ||
                                                    !formData.effectiveDate
                                                    ? "not-allowed"
                                                    : "pointer",
                                        }}
                                        disabled={
                                            loading ||
                                            !formData.chargeName.trim() ||
                                            !formData.chargeType ||
                                            !formData.type ||
                                            !formData.amount ||
                                            !formData.effectiveDate
                                        }
                                    >
                                        Submit
                                    </Button>
                                </div>

                            </form>
                        </CardContent>
                    </Card>


                    <Dialog
                        open={showConfirmationDialog}
                        // onClose={() => setShowConfirmationDialog(false)}
                        PaperProps={{
                            style: {
                                borderRadius: '16px',
                                padding: '20px',
                            }
                        }}
                    >
                        <DialogTitle style={{ textAlign: 'center', padding: '16px 24px' }}>
                            <CheckCircleIcon
                                style={{
                                    fontSize: 60,
                                    color: "#4caf50",
                                    marginBottom: '10px'
                                }}
                            />
                            <Typography variant="h6" style={{ color: '#4caf50' }}>
                                Successfully

                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText style={{ textAlign: 'center', fontSize: '16px' }}>
                                Miscellaneous Charge has been <br /> Created Successfully and Applied <br /> on Current Bill
                            </DialogContentText>

                        </DialogContent>
                        <DialogActions style={{ justifyContent: 'center', padding: '16px 24px' }}>

                            <Button
                                onClick={handleConfirmSubmit}
                                variant="contained"
                                style={{
                                    backgroundColor: '#14AE78',
                                    color: 'white'
                                }}
                                fullWidth
                                autoFocus
                            >
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </div>
    );
};

export default MiscChargeFormComponent;